<div class="container" *transloco="let t">
  <div class="full-width-container flex flex-row-reverse space-between margin-bottom-12">
  </div>
  <app-display-map
    [options]="mapOptions"
    [goToMyLocationBtn]="true"
    [rememberLastCenter]="true"
    (clickOnObelisk)="goToEditObelisk($event)"
    (mapMoveEnd)="onMapMoveEnd($event)"
    (mapZoom)="onMapZoom($event)"
  >
  </app-display-map>

  @if (generatedCount.value(); as count) {
    <div class="stats-overlay">
      <div class="stats-card">
        <div class="stats-title">{{t('generatedPlaces')}}</div>
        <div class="stats-grid">
          <div class="stat-item">
            <div class="stat-value">{{ count.total }}</div>
            <div class="stat-label">{{t('total')}}</div>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <div class="stat-value">{{ count.last24Hours }}</div>
            <div class="stat-label">{{t('last24Hours')}}</div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
